import { LinkButton, useAnalytics } from "../..";
import { UiCardModel } from "../../models";
import { isBackgroundFieldArray } from "../../styles";
import { MapModelToProps } from "../../utils";

import { Card, CardLink } from "./UiCard.styles";

export type UiCardProps = MapModelToProps<UiCardModel>;

const UiCard = ({ model }: UiCardProps) => {
    const {
        entryTitle,
        title,
        content,
        decoration,
        linkText,
        linkAppearance,
        route
    } = model.content;

    const { sendTrackEvent } = useAnalytics();

    return linkText ? (
        <Card
            $decoration={
                isBackgroundFieldArray(decoration) ? decoration : undefined
            }
            $appearance={linkAppearance}
        >
            <h3>{title}</h3>
            <p>{content}</p>
            {route.content && (
                <LinkButton
                    url={route.content.path}
                    appearance={linkAppearance}
                    prominence="Reduced"
                    isBlock={true}
                    onClick={() =>
                        sendTrackEvent("clickedUiCard", {
                            event: "clicked",
                            eventComponent: "CTA",
                            eventContainer: model.type,
                            label: `${title}_${linkText}`,
                            labelEnglish: entryTitle,
                            uuid: model.id,
                            href: route.content.path,
                            theme: linkAppearance
                        })
                    }
                    testId="cta"
                >
                    {linkText}
                </LinkButton>
            )}
        </Card>
    ) : route.content ? (
        <CardLink
            $decoration={
                isBackgroundFieldArray(decoration) ? decoration : undefined
            }
            href={route.content.path}
            onClick={() =>
                sendTrackEvent("clickedUiCard", {
                    event: "clicked",
                    eventComponent: model.type,
                    eventContainer: "content",
                    label: title,
                    labelEnglish: entryTitle,
                    uuid: model.id,
                    href: route.content.path
                })
            }
            data-testid="card-link"
        >
            <h3>{title}</h3>
            <p>{content}</p>
        </CardLink>
    ) : null;
};

export default UiCard;
